import video from "@/api/video";

const state = {
    videos: []
};

const getters = {
    videos: state => {
        return state.videos;
    },
    currentPaginateVideos: state => {
        return state.videos.data
            ? [...state.videos.data].sort(function(a, b) {
                return new Date(b.date) - new Date(a.date);
            })
            : [];
    }
};

const actions = {
    get({ commit }, params = null) {
        return video
            .get(params)
            .then(response => {
                if (response.status === 200) {
                    commit("SET_VIDEOS", response.data.data);
                }
                return response;
            })
            .catch(error => {
                console.log("error " + error);
                return error;
            });
    },
    update({ commit }, data) {
        return video
            .update(data.id, data)
            .then(response => {
                if (response.status === 200) {
                    commit("UPDATE_VIDEO", response.data.data);
                }
                return response;
            })
            .catch(error => {
                console.log("error " + error);
                return error;
            });
    }
};

const mutations = {
    SET_VIDEOS(state, value) {
        state.videos = value;
    },
    UPDATE_VIDEO(state, value) {
        state.videos.data = [
            ...state.videos.data.filter(video => video.id !== value.id),
            value
        ];
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
